// Cars card game data with rankings
export const CARS_CARDS = [
  { id: 1, name: "Toyota", rank: 1 ,
    image: "/images/cars/cars_1.jpg"
  },
  { id: 2, name: "Ford", rank: 2 ,
    image: "/images/cars/cars_2.jpg"
  },
  { id: 3, name: "Chevrolet", rank: 3 ,
    image: "/images/cars/cars_3.jpg"
  },
  { id: 4, name: "Honda", rank: 4 ,
    image: "/images/cars/cars_4.jpg"
  },
  { id: 5, name: "Nissan", rank: 5 ,
    image: "/images/cars/cars_5.jpg"
  },
  { id: 6, name: "Hyundai", rank: 6 ,
    image: "/images/cars/cars_6.jpg"
  },
  { id: 7, name: "Kia", rank: 7 ,
    image: "/images/cars/cars_7.jpg"
  },
  { id: 8, name: "Subaru", rank: 8 ,
    image: "/images/cars/cars_8.jpg"
  },
  { id: 9, name: "GMC", rank: 9 ,
    image: "/images/cars/cars_9.jpg"
  },
  { id: 10, name: "Jeep", rank: 10 ,
    image: "/images/cars/cars_10.jpg"
  },
  { id: 11, name: "Mazda", rank: 11 ,
    image: "/images/cars/cars_11.jpg"
  },
  { id: 12, name: "Ram", rank: 12 ,
    image: "/images/cars/cars_12.jpg"
  },
  { id: 13, name: "Lexus", rank: 13 ,
    image: "/images/cars/cars_13.jpg"
  },
  { id: 14, name: "BMW", rank: 14 ,
    image: "/images/cars/cars_14.jpg"
  },
  { id: 15, name: "Volkswagen", rank: 15 ,
    image: "/images/cars/cars_15.jpg"
  },
  { id: 16, name: "Mercedes-Benz", rank: 16 ,
    image: "/images/cars/cars_16.jpg"
  },
  { id: 17, name: "Buick", rank: 17 ,
    image: "/images/cars/cars_17.jpg"
  },
  { id: 18, name: "Cadillac", rank: 18 ,
    image: "/images/cars/cars_18.jpg"
  },
  { id: 19, name: "Audi", rank: 19 ,
    image: "/images/cars/cars_19.jpg"
  },
  { id: 20, name: "Acura", rank: 20 ,
    image: "/images/cars/cars_20.jpg"
  },
  { id: 21, name: "Volvo", rank: 21 ,
    image: "/images/cars/cars_21.jpg"
  },
  { id: 22, name: "Land Rover", rank: 22 ,
    image: "/images/cars/cars_22.jpg"
  },
  { id: 23, name: "Chrysler", rank: 23 ,
    image: "/images/cars/cars_23.jpg"
  },
  { id: 24, name: "Lincoln", rank: 24 ,
    image: "/images/cars/cars_24.jpg"
  },
  { id: 25, name: "Mitsubishi", rank: 25 ,
    image: "/images/cars/cars_25.jpg"
  },
  { id: 26, name: "Dodge", rank: 26 ,
    image: "/images/cars/cars_26.jpg"
  },
  { id: 27, name: "Porsche", rank: 27 ,
    image: "/images/cars/cars_27.jpg"
  },
  { id: 28, name: "Genesis", rank: 28 ,
    image: "/images/cars/cars_28.jpg"
  },
  { id: 29, name: "Infiniti", rank: 29 ,
    image: "/images/cars/cars_29.jpg"
  },
  { id: 30, name: "Mini", rank: 30 ,
    image: "/images/cars/cars_30.jpg"
  }
];
